import React from "react";
import styles from "./LeftRail.module.css";

export default function LeftRail({ viewMode, onChangeViewMode }) {
  return (
    <aside className={styles.rail}>
      <div className={styles.group}>
        <div className={styles.logo} title="FrameFlow">
          <span className="material-symbols-outlined fill" style={{ fontSize: 18 }}>
            movie
          </span>
        </div>

        <button
          className={`${styles.railButton} ${
            viewMode === "edit" ? styles.railButtonActive : ""
          }`}
          onClick={() => onChangeViewMode("edit")}
          title="Storyboard"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
            view_timeline
          </span>
        </button>

        <button
          className={`${styles.railButton} ${
            viewMode === "player" ? styles.railButtonActive : ""
          }`}
          onClick={() => onChangeViewMode("player")}
          title="Reproducir animática"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
            play_circle
          </span>
        </button>
      </div>
    </aside>
  );
}
